// flow weak

import React, {
    PureComponent
  }                             from 'react';
  import PropTypes              from 'prop-types';
  import AnimatedView           from '../../../../components';
  import styles                 from './style'
  import {
    defaultOptions,
    checkStatus,
    parseJSON,
    getLocationOrigin
  }                     from '../../../../services/fetchTools';
  import { withRouter } from 'react-router';
  import DatePicker from 'react-datepicker';
  import moment from 'moment';
  import styled from 'styled-components'
  import FlatButton from 'material-ui/FlatButton';
  import Dialog from 'material-ui/Dialog'
  import { Spinner } from 'react-activity';
  import 'react-activity/dist/react-activity.css';
  
  
  class CriticalTimeSlot extends PureComponent {
    static propTypes = {
      actions: PropTypes.shape({
        enterPage: PropTypes.func,
        leavePage: PropTypes.func,
      })
    };
  
    constructor(props) {
      super(props);
      this.state = {
        venue:props.props.statsTable.revenue_per_month.requested_venue_id,
        slots:[],
        activity_state:true,
        check_click:false,
        customer_count:0,
        week_customers_count:0,
        month_customers_count:0,
        slot:{}
      }
      this.checkClick = this.checkClick.bind(this);
      this.handleClose = this.handleClose.bind(this);
      this.onNotifyClick = this.onNotifyClick.bind(this);
  
    }
  
    handleClose(){
        this.setState({check_click:false,})
    }
  
    componentDidMount(){
        this.getCriticalSlot()
        console.log("componentDidMount")
    }

    checkClick(slot){
        this.setState({activity_state:true,slot:slot})
        this.getCustomerGroup(slot)

    }

    locationChanged() {
      this.setState({venue:this.props.props.statsTable.revenue_per_month.requested_venue_id}, () => {
        this.getCriticalSlot()
      })
    }

    onNotifyClick(code){
        const url = `${getLocationOrigin()}/cm/notify_critical_slot_to_suggested_cust/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({
                            'start_time': this.state.slot.start_time,
                            'venue_id': this.state.slot.court__venue,
                            'game_name':this.state.slot.court__game__name,
                            'date':this.state.slot.date,
                            "code":code
                            });
        
        return fetch(url, options)
            .then(checkStatus)
            .then(parseJSON)
            .then(data => {
                alert(data.message)
            });
    }

    getCustomerGroup(slot){
        const url = `${getLocationOrigin()}/cm/get_suggested_groups_for_critical_slot/?venue_id=${slot.court__venue}&date=${slot.date}&start_time=${slot.start_time}&game_name=${slot.court__game__name}`;
        const options = {...defaultOptions};

        return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then(data => {
            this.setState({check_click:true,activity_state:false,day_code:data.day_code,month_code:data.month_code,week_code:data.week_code,customer_count:data.customer_count,week_customers_count:data.week_customers_count,month_customers_count:data.month_customers_count});
        }).catch(error => error);
    }

    getCriticalSlot(){
        const url = `${getLocationOrigin()}/cm/get_critical_time_slots/?venue_id=${this.state.venue}`;
        const options = {...defaultOptions};

        return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then(data => {
            this.setState({slots:data.result,activity_state:false});
        }).catch(error => error);
    }
    
  
    render() {

        if(this.state.venue != this.props.props.statsTable.revenue_per_month.requested_venue_id){
          this.locationChanged()
        }


        const dialog_actions = [
            <FlatButton
              label="--"
              primary={true}
              onClick={this.handleClose}
            />,
            <FlatButton
              label="--"
              primary={true}
              onClick={this.postActivityStatus}
            />,
          ];
            
      return(
        <div style={styles.container}>
            {this.state.activity_state ? 
            <div style={{position:'absolute',marginTop:'30%',marginLeft:'40%'}}>
                <Spinner size="50" />
            </div>
            :
            this.state.check_click && 
              <div className="col col-md-12" style={styles.card}>
                <div className="col-md-12" style={styles.booking}>Notification</div>

                <div className="row col-md-12" style={styles.card_header}>  
                    <span className='col-md-4' style={styles.card_contents}>Group 1 (Prev Week)</span>
                    <span className='col-md-4' style={styles.card_contents}>Group 2 (Last Seven Days)</span>
                    <span className='col-md-4' style={styles.card_contents}>Group 3 (Last One month)</span>                  
                </div>
                
                <div style={styles.cart_rows} className="row col-md-12">
                    <hr/>
                    <span className='col col-md-4' style={styles.card_contents}>{this.state.customer_count}</span>
                    <span className='col col-md-4' style={styles.card_contents}>{this.state.week_customers_count} </span>
                    <span className='col col-md-4' style={styles.card_contents}>{this.state.month_customers_count}</span>
                    <hr/>
                </div>

                <div style={styles.cart_rows} className="row col-md-12">
                    <hr/>
                    <span className='col col-md-4' style={styles.card_contents}> <input type="button" value="Notify" style={{'backgroundColor':"#32B6A7",'fontSize':"18px"}}  onClick={()=>{this.onNotifyClick(this.state.day_code)}} /></span>
                    <span className='col col-md-4' style={styles.card_contents}> <input type="button" value="Notify" style={{'backgroundColor':"#32B6A7",'fontSize':"18px"}}  onClick={()=>{this.onNotifyClick(this.state.week_code)}} /></span>
                    <span className='col col-md-4' style={styles.card_contents}> <input type="button" value="Notify" style={{'backgroundColor':"#32B6A7",'fontSize':"18px"}}  onClick={()=>{this.onNotifyClick(this.state.month_code)}} /></span>
                    <hr/>
                </div>
                
              </div>
            }
            <div className="col-md-12" style={{'marginTop':20,'padding':10,'display':"flex",'flexDirection':"row",'backgroundColor':"#C993FF"}}>
                  <div className="col-md-3" >
                    Date
                  </div>  
                  
                  <div className="col-md-3" >
                    TIme
                  </div>
                  
                  <div className="col-md-3" >
                    Venue
                  </div>

                  <div className="col-md-3" >
                    Game
                  </div>

                  <div className="col-md-3" >
                    Remaining Slot
                  </div>
                  <div className="col-md-3" >
                    Notify
                  </div>
            </div>
            {this.state.activity_state ? 
            <div style={{position:'absolute',marginTop:'30%',marginLeft:'40%'}}>
                <Spinner size="50" />
            </div>
            :
            this.state.slots.map((slot,index) =>
                <div className="col-md-12" style={{'padding':10,'display':"flex",'flexDirection':"column",'backgroundColor':"white",'marginTop':"2px"}}>
                    <div style={{'display':"flex",'flexDirection':"row"}}>
                        <div className="col-md-3" >
                            {slot.date}
                        </div>
                        <div className="col-md-3" >
                            {slot.start_time}
                        </div>
                        <div className="col-md-3" >
                            {slot.court__venue__name}
                        </div>
                        <div className="col-md-3" >
                            {slot.court__game__name}
                        </div>
                        <div className="col-md-3" >
                            {slot.count}
                        </div>
                        <div className="col-md-3" >
                        <input type="button" value="Check" style={{'backgroundColor':"#48CB60",'fontSize':"18px"}}  onClick={()=>{this.checkClick(slot)}} />
                        </div>
                    </div>
                </div>
            )}
            {/* {this.state.check_click &&
                <Dialog
                    modal={false}
                    open={this.state.check_click}
                    onClick={this.handleClose}
                    onRequestClose={()=>{this.setState({check_click:false})}}
                    autoDetectWindowHeight={true}
                    autoScrollBodyContent={true}
                    scroll={scroll}
                    dividers={scroll === 'paper'}
                >
                <div className="col-md-12">
                    <div style={{color: '#32B6A7',fontSize: '130%',textAlign:'center',borderBottom: '1px solid',}}>Notification</div>
                </div> 
                <div className="col-md-12" style={{paddingTop:10}}>
                    <div className="col-md-4" style={{textAlign:'center'}}>
                        Group 1 (Prev Week)
                    </div>
                    <div className="col-md-4" style={{textAlign:'center'}}>
                        Group 2 (Last Seven Days)
                    </div>
                    <div className="col-md-4" style={{textAlign:'center'}}>
                        Group 3 (Last One month)
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="col-md-4" style={{textAlign:'center',paddingTop:10}}>
                        <div>
                            <div>{this.state.customer_count}</div>
                            <input type="button" value="Notify" style={{'backgroundColor':"#32B6A7",'fontSize':"18px"}}  onClick={()=>{this.checkClick(slot)}} />
                        </div>
                    </div>

                    <div className="col-md-4" style={{textAlign:'center',paddingTop:10}}>
                        <div>
                            <div>{this.state.week_customers_count}</div>
                            <input type="button" value="Notify" style={{'backgroundColor':"#32B6A7",'fontSize':"18px"}}  onClick={()=>{this.checkClick(slot)}} />
                        </div>
                        
                    </div>
                    <div className="col-md-4" style={{textAlign:'center',paddingTop:10}}>
                        <div>
                            <div>{this.state.month_customers_count}</div>
                            <input type="button" value="Notify" style={{'backgroundColor':"#32B6A7",'fontSize':"18px"}}  onClick={()=>{this.checkClick(slot)}} />
                        </div>
                        
                    </div>
                </div>
                </Dialog>
            } */}
        </div>
      );
    }
  }
  
  export default CriticalTimeSlot;
  


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/CriticalTimeSlot/index.js